const isNonEmptyString = (str) => typeof str === 'string' && str.length > 0
export { isNonEmptyString }
